import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import ReplaceCardModal from '../Modals/ReplaceCardModal';
import PatientEnrollModal from '../Modals/PatientEnrollModal';

const FormList = (props) => {
  const forms = props.forms.map((form, key) => {
    // show replace modal
    if (form.linkTo.includes('/replace/patient-information')) {
      return (
        <ReplaceCardModal
          key={ key }
          isHCP={
            form.linkTo.includes('hps') || form.linkTo.includes('pharmacist')
          }
          trigger={
            <Button to={ '' } className={ `form-type track ${form.tracking}` }>
              <span className="title">{form.name}</span>
              <span className="description">{form.description}</span>
            </Button>
          }
        />
      );
    }

    if (form.linkTo.includes('patient/enroll/eligibility')) {
      return (
        <PatientEnrollModal
          key={ key }
          linkTo={ form.linkTo }
          trigger={
            <Button to={ '' } className={ `form-type track ${form.tracking}` }>
              <span className="title">{form.name}</span>
              <span className="description">{form.description}</span>
            </Button>
          }
        />
      );
    }

    return (
      <Button
        key={ key }
        as={ Link }
        to={ form.linkTo }
        className={ `form-type track ${form.tracking}` }
      >
        <span className="title">{form.name}</span>
        <span className="description">{form.description}</span>
      </Button>
    );
  });
  return (
    <div
      className="form-list"
      style={ props.forms && props.forms.length ? { padding: '0' } : {} }
    >
      {props.forms && props.forms.length
        ? (
          <p>How can we help you today?</p>
        )
        : (
          ''
        )}
      <div className="list">{forms}</div>
    </div>
  );
};

FormList.propTypes = {
  forms: PropTypes.array,
};

export default FormList;
